const ShiftsEndPoints =  {
    GET_TRAVEL_BY_RANGE_DATE: `/api/travel/all/byRangeDate`,
    CREATE_TRAVEL: `/api/travel`,
    UPDATE_TRAVEL: `/api/travel/:id`,
    REMOVE_VEHICLE: `/api/travel/:id`,
}

export default ShiftsEndPoints